import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, CardBody, Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { commitFileLOCColDef, defaultColDef } from '../../../helpers/GitMetricColumnDef';

const CommitFileLOCDetails = ({ fileLOC, commitMessage, hideTable, platform }) => {
    const [fileLOCColDef, setFileLOCColDef] = useState(commitFileLOCColDef);

    const hasAddedColumn = useRef(false);

    useEffect(() => {
        if (
            platform === "AzureDevOps" &&
            !hasAddedColumn.current
        ) {
            const colDef = [...commitFileLOCColDef];
            colDef.splice(2, 0, {
                field: "changesCountModified",
                headerName: "# LOC: Modified",
                headerTooltip: "Number of Modified Lines",
                filter: "agNumberColumnFilter",
                width: 120,
                type: "numericColumn",
                valueGetter: (params) => {
                    const total = Number(params.data?.totalLines || 0);
                    const removed = Number(params.data?.removedLines || 0);
                    const added = Number(params.data?.addedLines || 0);
                    return total - removed - added;
                }
            });
            setFileLOCColDef(colDef);
            hasAddedColumn.current = true;
        } else if (platform !== "AzureDevOps") {
            setFileLOCColDef(commitFileLOCColDef);
            hasAddedColumn.current = false;
        }
    }, [platform]);

    fileLOCColDef.forEach(column => {
        if (column["field"] === "changesCountModified") {
            column["cellRenderer"] = changesCountModifiedRenderer
        }
    });

    return (
        <Container style={{ padding: '0px' }}>
            <Card className='w-full file-loc-card'>
                <CardBody className='file-loc-cardbody'>
                    <Row className="align-items-center">
                        <Col xs={9}>
                            <h6>Commit Message: {commitMessage}</h6>
                        </Col>
                        <Col xs={3} className="text-end">
                            <Button variant="outline" onClick={hideTable} style={{ marginBottom: '10px', width: '40px' }}>
                                {'X'}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className={`ag-theme-quartz file-loc-commit`}>
                            <AgGridReact
                                rowData={fileLOC}
                                columnDefs={fileLOCColDef}
                                defaultColDef={defaultColDef}
                                className="ag-grid-style file-loc-commit"
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Container>
    )
}

function changesCountModifiedRenderer(params) {
    let modifiedLOC = (params["data"].totalLines || 0)
        - (params["data"].removedLines || 0)
        - (params["data"].addedLines || 0);
    return (
        <div>
            {`${modifiedLOC}`}
        </div>
    )
}

CommitFileLOCDetails.propTypes = {
    fileLOC: PropTypes.array.isRequired,
    commitMessage: PropTypes.string.isRequired,
    hideTable: PropTypes.func.isRequired,
    platform: PropTypes.string.isRequired,
}

export default CommitFileLOCDetails;